<!-- CONTACT FORM START-->
<section class="section " id="contact">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1 class="section-title text-center">Get In Touch</h1>
        <div class="section-title-border mt-3"></div>
        <p class="section-subtitle text-muted text-center font-secondary pt-4">Stay in touch to be aware of the launch
          of other services and be the first to try them.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4" style="width: 100%;">
        <div class=" mt-4 pt-4" style=" display: flex; justify-content: space-around; flex-wrap: wrap;">
          <p class="mt-4"><span class="h5">Office Address:</span><br> <span class="text-muted d-block mt-2">272 Bath
              Street, Glasgow, Scotland, G2 4JR</span></p>
          <p class="mt-4"><span class="h5">Working Hours:</span><br> <span class="text-muted d-block mt-2">9:00AM To
              6:00PM</span></p>
          <p class="mt-4"><span class="h5"><a href="https://garuda.ai/" target="_blank">GARUDA.AI LLC</a> </span> is an official representative in Ukraine.<br>
        </div>
      </div>
      <!--<div class="col-lg-8">
        <div class="custom-form mt-4 pt-4">
          <div id="message"></div>
          <form method="post" (ngSubmit)="createJob()" [formGroup]="itemData">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group mt-2">
                  <input name="name" id="name" type="text" class="form-control" placeholder="Your name*"
                    formControlName="name" [ngClass]="{ 'is-invalid': submitted && form['name'].errors }" required>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mt-2">
                  <input name="email" id="email" type="email" class="form-control" placeholder="Your email*"
                    [ngClass]="{ 'is-invalid': submitted && form['email'].errors }" formControlName="email" required>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group mt-2">
                  <input type="text" class="form-control" id="subject" placeholder="Your Subject.."
                    formControlName="subject" [ngClass]="{ 'is-invalid': submitted && form['subject'].errors }"
                    required />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group mt-2">
                  <textarea name="comments" id="comments" rows="4" class="form-control" placeholder="Your message..."
                    [ngClass]="{ 'is-invalid': submitted && form['description'].errors}" formControlName="description"
                    required></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 text-end">
                <input type="button" id="submit" name="send" class="submitBnt btn btn-primary" value="Send Message">
                <div id="simple-msg"></div>
              </div>
            </div>
          </form>
        </div>
      </div>-->
    </div>
  </div>
</section>
<!-- CONTACT FORM END-->
<!--START SOCIAL-->
<section class="contact-social bg-light">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <ul class="list-inline social mt-4">
          <li class="list-inline-item"><a href="https://www.facebook.com/groups/algebraictechnologies" class="social-icon"><i class="mdi mdi-facebook"></i></a>
          </li>
          <li class="list-inline-item"><a href="https://www.linkedin.com/company/algebraic-technologies/" class="social-icon"><i class="mdi mdi-linkedin"></i></a>
          </li>
        </ul>
      </div>
      <!--<div class="col-lg-3 mt-4">
        <p class="contact-title"><i class="pe-7s-call"></i> &nbsp;+91 123 4556 789</p>
      </div>-->
      <div class="col-lg-3 mt-4 text-end">
        <p class="contact-title"><i class="pe-7s-mail-open"></i>&nbsp; board@altech.org.uk</p>
      </div>
    </div>
  </div>
</section>
<!--END SOCIAL-->